import {
  AboutPage,
  CatalogPage,
  ContactPage,
  Customer,
  FabricationPage,
  LandingPage,
  Login,
  MagicLogin,
  MerchPage,
  OrderPage,
  OrdersManagementPage,
  OrderSuccessPage,
  ProductDetailPage,
  ProductsPage,
  ProductsManagementPage,
  SettingsPage,
  TalentPoolPage,
  TestimonialsManagementPage,
  UsersPage
} from '@components/pages';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PrivateTemplate, PublicTemplate } from './@components/templates';

function App() {
  return (
    <Routes>
      <Route path="/" element={<PublicTemplate />}>
        <Route index element={<LandingPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="fabrication" element={<FabricationPage />} />
        <Route path="catalog" element={<CatalogPage />} />
        {/* <Route path="careers" element={<CareersPage />} /> */}
        <Route path="talent-pool" element={<TalentPoolPage />} />
        {/* <Route path="careers/:positionId" element={<CareerDetailsPage />} /> */}
        <Route path="loja" element={<ProductsPage />} />
        <Route path="merch" element={<MerchPage />} />
        <Route path="merch/:id" element={<ProductDetailPage />} />
        <Route path="orders/:orderId" element={<OrderPage />} />
        <Route path="order-success" element={<OrderSuccessPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="settings" element={<SettingsPage />} />
        {/* <Route path="quote" element={<QuotePage />} /> */}
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:userId" element={<UsersPage />} />
        <Route path="products/:id" element={<ProductDetailPage />} />
        <Route path="/products" element={<ProductsManagementPage />} />
        <Route path="/orders" element={<OrdersManagementPage />} />
        <Route path="/testimonials" element={<TestimonialsManagementPage />} />
      </Route>
      <Route path="/app" element={<PrivateTemplate />}>
        <Route index element={<Navigate to="/app/clientes" replace />} />
        <Route path="clientes/">
          <Route index element={<Customer />} />
        </Route>
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/magic-login" element={<MagicLogin />} />
      {/* <Route path="/reset-password" element={<ChangePassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />} /> */}
    </Routes>
  );
}

export default App;
